import BaseView from "./_BaseView";
import {TimelineMax, TweenMax} from 'gsap';
import Api from "../Api";
import Confirm from "../components/Confirm";
import $ from "jquery";
import trans from "../util/trans";

export default class SegmentWizardView extends BaseView {
    constructor() {
        super();
        this.sf = $('.step-form');
        this.index = 0;
    }

    init() {
        super.init();
        this.sortables();
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const stepForm = $('.step-form');
        if (stepForm.length > 0) {
            window.onbeforeunload = () => {
                return true;
            };


            this.sf.on('click', '.next', function () {
                self.sf.find('.steps form.active').trigger('submit.next');
                return false;
            });

            this.sf.on('click', '.prev', function () {
                self.sf.find('.steps form.active').trigger('submit.prev');
                self.prev();
                return false;
            });

            this.sf.on('click', '.sf-breadcrumbs li:not(.disabled) a', function () {
                self.sf.find('.steps form.active').trigger('submit.goto');
                const index = $('.sf-breadcrumbs li').index($(this).parents('li'));
                // $(this).parents('li').nextAll('li').addClass('disabled');
                self.goto(index);
            });

            // apps
            this.sf.on('active', '.sf-2', function () {
                $('form.sf-3').removeClass('initialized');
                self.linkedLists('2');
            });

            // roles
            this.sf.on('active', '.sf-3', function () {
                self.linkedLists('3');
            });

            // criteria
            // this.sf.on('active', '.sf-4', function () {
            //     self.loadCriteria();
            // });

            // pathways
            this.sf.on('active', '.sf-5', function () {
                $('form.sf-5').removeClass('initialized');
                self.linkedLists('5');
            });

            // guides
            this.sf.on('active', '.sf-6', function () {
                self.linkedLists('6');
            });

            // this.sf.on('click', '.add-segment-criteria', function () {
            //     const id = $('.select-segment-criteria').val();
            //     Api.send(`/api/criteria/${id}`).done(function (r) {
            //         $('.criteria-container').append(self.buildCriteriaHtml(r));
            //         self.index++;
            //     });
            //     return false;
            // });
            //
            // this.sf.on('click', '.remove-criteria', function () {
            //     $(this).parents('.criteria-item').remove();
            // });

            this.sf.on('submit.next submit.prev submit.goto', '.steps form', function (e) {
                const form = $(this);
                // console.log(e);

                const action = form.attr('action'),
                    method = form.attr('method');

                let data = form.aeroSerialize();

                if (form.isFormValid()) {
                    if (form.is(':first-child')) {
                        Api.send(action, data, method).done(function (r) {
                            if (method === 'post') {
                                form.attr('method', 'patch');
                                form.attr('action', `/api/segments/${r._id}`);
                                self.sf.data('id', r._id);
                                $('form.sf-2').attr('action', `/api/segments/${r._id}/apps`);
                                $('form.sf-3').attr('action', `/api/segments/${r._id}/roles`);
                                // $('form.sf-4').attr('action', `/api/segments/${r._id}/criteria`);
                                $('form.sf-5').attr('action', `/api/segments/${r._id}/pathways`);
                                $('form.sf-6').attr('action', `/api/segments/${r._id}/guides`);
                            }
                            if (e.namespace === 'next') {
                                self.next();
                            }
                        });
                    } else if (form.hasClass('sf-4')) {
                        // data = form.serializeObject();
                        // if (data.criteria) {
                        //     for (let i = 0; i < data.criteria.length; ++i) {
                        //         data.criteria[i].parameter = data.criteria[i].parameter === '1';
                        //     }
                        // }
                        // Api.send(action, data, method).done(function (r) {
                        //     self.next();
                        // });
                    } else {
                        const ids = [];
                        form.find('.linked li').each(function () {
                            let id = $(this).data('id');
                            if (id) {
                                ids.push(id);
                            }
                        });

                        if (form.hasClass('disallow-empty') && ids.length === 0) {
                            form.prepend(`<div class="aero-error-box"><ul><li>${Lang.itemrequired}</li></ul></div>`);
                            return false;
                        }
                        $('.aero-error-box').remove();

                        data = {ids: ids};
                        Api.send(action, data, method).done(function () {
                            if (form.is('.sf-6') && e.namespace === 'next') {
                                window.onbeforeunload = null;
                                window.location = '/segments';
                            } else if (e.namespace === 'next') {
                                self.next();
                            }
                        });
                    }
                } else {

                }
                return false;
            });

            $('form.sf-2').on('submit', function () {
                $('form.sf-3').removeClass('initialized');
            });

            if ($('.step-form').hasClass('default')) {
                $('.sn-2').parents('li').removeClass('disabled');
                $('.sn-3').parents('li').removeClass('disabled');
                $('.sf-2').removeClass('disallow-empty');
                this.goto(2);
            }
        }
    }

    next() {
        const current = this.sf.find('.steps form.active');
        let next = current.next('form');
        const tl = new TimelineMax({paused: true});

        if (next.hasClass('skip')) {
            next = next.next('form');
        }

        TweenMax.set([next, current], {
            backfaceVisibility: "hidden"
        });

        TweenMax.set(next, {rotationY: -180});
        tl.to(current, 0.5, {rotationY: 180})
            .call(function () {
                next.addClass('active');
                current.removeClass('active');
            })
            .to(next, 0.5, {rotationY: 0}, '-=.1');
        tl.play();

        const index = $('form').index(next);
        $('.sf-breadcrumbs li').removeClass('active').each(function (i) {
            if (i === index) {
                $(this).addClass('active').removeClass('disabled');
            }
        });
        next.trigger('active');
    }

    prev() {
        const current = this.sf.find('.steps form.active');
        let prev = current.prev('form');
        const tl = new TimelineMax({paused: true});

        if (prev.hasClass('skip')) {
            prev = prev.prev('form');
        }

        TweenMax.set(prev, {rotationY: -180});
        tl.to(current, 0.5, {rotationY: 180})
            .call(function () {
                prev.addClass('active');
                current.removeClass('active');
            })
            .to(prev, 0.5, {rotationY: 0}, '-=.1');
        tl.play();

        const index = $('form').index(prev);
        $('.sf-breadcrumbs li').removeClass('active').each(function (i) {
            if (i === index) {
                $(this).addClass('active');
            }
        });
        prev.trigger('active');
    }

    goto(index) {
        const current = this.sf.find('.steps form.active');

        const prev = $(`.steps form:eq(${index})`);
        const tl = new TimelineMax({paused: true});

        TweenMax.set([prev], {
            backfaceVisibility: "hidden"
        });

        TweenMax.set(prev, {rotationY: -180});
        tl.to(current, 0.5, {rotationY: 180})
            .call(function () {
                prev.addClass('active');
                current.removeClass('active');
            })
            .to(prev, 0.5, {rotationY: 0}, '-=.1');
        tl.play();

        const menuIndex = $('form').index(prev);
        $('.sf-breadcrumbs li').removeClass('active').each(function (i) {
            if (i === menuIndex) {
                $(this).addClass('active');
            }
        });
        prev.trigger('active');
    }

    sortables() {
        const self = this;
        $('.unlinked, .linked').sortable({
            connectWith: '.ui-sortable',
            items: 'li:not(.static-item)'
        });


        //Delete
        this.sf.on('click', '.delete', function () {
            const $li = $(this).parents('li:eq(0)');
            //Confirm
            Confirm({
                title: Lang.unlink,
                msg: Lang.remsure,
                onConfirm: function () {
                    const items = $li.parents('form').find('.unlinked');
                    items.append(SegmentWizardView.buildListHtml({
                        id: $li.data('id'),
                        title: $li.find('.title').text()
                    }));
                    $li.remove();
                    // self.updateLinked();
                }
            });
            return false;
        });

        // selecting all items in the list
        this.sf.on('change', '.select-all', function () {
            $(this).parents('.grid-item').find('ul input').prop('checked', $(this).prop('checked'));
        });

        this.sf.on('click', '.add-selected', function () {
            const linked = $(this).parents('form').find('.linked');
            $(this).parents('form').find('.unlinked input:checked').each(function () {
                let id = $(this).parents('li').data('id');
                let title = $(this).parents('li').find('.title').text();
                linked.append(SegmentWizardView.buildListHtml({id: id, title: title}));
                $(this).parents('li').remove();
            });

            // self.updateLinked();
        });

        this.sf.on('click', '.delete-selected', function () {
            const unlinked = $(this).parents('form').find('.unlinked');
            const checked = $(this).parents('form').find('.linked input:checked');
            Confirm({
                title: Lang.unlink,
                msg: trans('unlinkx', {x: checked.length}),
                onConfirm: function () {
                    checked.each(function () {
                        let id = $(this).parents('li').data('id');
                        let title = $(this).parents('li').find('.title').text();
                        unlinked.append(self.buildListHtml(id, title));
                        $(this).parents('li').remove();
                    });
                    // self.updateLinked();
                }
            });
            return false;
        });
    }

    static buildListHtml(item) {
        return `<li ${!item.from_pathways ? `data-id="${item.id}"` : 'class="static-item"'}>
            <span class="control"><input type="checkbox"></span>
            <span class="title">${item.title}</span>
            ${item.from_pathways ? `<span class="static">${item.from_pathways}</span>` : ''}
            <a class="delete btn btn-warning"><i class="jsicon-trashcan"></i></a>
            </li>`;
    }

    linkedLists(step) {
        const form = this.sf.find('form.sf-' + step);
        if (!form.hasClass('initialized')) {
            form.find('ul').empty();
            Api.send(form.attr('action')).done(function (r) {
                const unlinked = form.find('.unlinked');
                const linked = form.find('.linked');
                for (let i = 0; i < r.unlinked.length; i++) {
                    unlinked.append(SegmentWizardView.buildListHtml(r.unlinked[i]));
                }
                for (let i = 0; i < r.linked.length; i++) {
                    linked.append(SegmentWizardView.buildListHtml(r.linked[i]));
                }
                form.addClass('initialized');
            });
        }
    }

    loadCriteria() {
        const self = this;
        const form = this.sf.find('form.sf-4');
        if (!form.hasClass('initialized')) {
            const container = form.find('.criteria-container');
            container.empty();
            Api.send(form.attr('action')).done(function (r) {
                for (let i = 0; i < r.length; ++i) {
                    container.append(self.buildCriteriaHtml(r[i]));
                }
            });
        }
    }

    buildCriteriaHtml(criteria) {
        return `<div class="criteria-item">
            <input type="hidden" name="criteria[${this.index}][parameter]" value="${criteria.parameter === true ? '1' : '0'}">
            <div class="grid four">
                <div class="grid-item">
                    <label class="aero-label">
                        ${criteria.name ? `<span>${criteria.name}</span>` : '<span>&nbsp;</span>'}
                        <input type="text" name="criteria[${this.index}][expression]" value="${criteria.expression ? criteria.expression : ''}">    
                    </label>
                </div>
                <div class="grid-item">
                    <label class="aero-label">
                        <span>is</span>
                        <select name="criteria[${this.index}][comparison]">
                            <option ${criteria.comparison === '==' ? 'selected' : ''} value="==">${Lang.eq}</option>
                            <option ${criteria.comparison === '<' ? 'selected' : ''} value="<">${Lang.lt}</option>
                            <option ${criteria.comparison === '<=' ? 'selected' : ''} value="<=">${Lang.lte}</option>
                            <option ${criteria.comparison === '>' ? 'selected' : ''} value=">">${Lang.gt}</option>
                            <option ${criteria.comparison === '>=' ? 'selected' : ''} value=">=">${Lang.gte}</option>
                            <option ${criteria.comparison === '!=' ? 'selected' : ''} value="!=">${Lang.ne}</option>
                        </select>  
                    </label>
                </div>
                <div class="grid-item">
                    <label class="aero-label">
                        <span>${Lang.value}</span>
                        <input type="text" name="criteria[${this.index}][value]" value="${criteria.value ? criteria.value : ''}">    
                    </label>
                </div>
                <div class="grid-item">
                    <label class="aero-label">
                        <span>&nbsp;</span>
                        <button type="button" class="remove-criteria btn btn-dark">${Lang.remove}</button>   
                    </label>
                </div>
            </div>    
        </div>`;
    }
}
